import { Component, OnInit, OnDestroy } from '@angular/core';
import { DialogComponent, DialogService } from 'ng2-bootstrap-modal';
import 'rxjs/add/operator/switchMap';
import { UtilsService } from '../services/utils.service';
import {LoginService} from '../services/login.service';
import {ModalService} from '../services/modalService/modal.service';
import {MessageResendModalComponent} from '../custom-modals/message-resend-modal.component';
import {Observable} from 'rxjs/Observable';

export interface VerifyYourEmailModalModel {
  title: string;
  data: any;
}

@Component({
  selector: 'app-verify-your-email-modal',
  templateUrl: './verify-your-email-modal.component.html',
  styleUrls: ['./verify-your-email-modal.component.css']
})
export class VerifyYourEmailModalComponent extends DialogComponent<VerifyYourEmailModalModel, boolean> implements OnInit, OnDestroy {
  title: string;
  subtitle: string;
  data: any;
  isSuccess: boolean;
  showResendMessagePopup: boolean;
  currentLang: string;
  
  constructor(dialogService: DialogService, 
  			  private utilsService: UtilsService,
  			  private loginService: LoginService,
  			  private modalService: ModalService) {
    super(dialogService);
  }
 
  ngOnInit() {
    this.isSuccess = true;
    this.showResendMessagePopup = false;
  	this.currentLang = localStorage.getItem('lang') || 'en';
  	setTimeout(function () {
            document.getElementsByTagName('body')[0].classList.add('modal-open');
    }, 310);
    if (this.data.message1) {
        this.data.message1 = this.utilsService.decodeHtml(this.data.message1);
    }
    if (this.data.message2) {
        this.data.message2 = this.utilsService.decodeHtml(this.data.message2);
    }
  }
  
  closeModal() {
      this.result = true;
      this.close();
  }
  
  closeResendMessagePopup()  {
  	  this.showResendMessagePopup = false;
  }
  
  resendEmail() {
  	this.loginService.resendEmailValidation().subscribe((res) => {
  		this.isSuccess = true;
  		this.showResendMessagePopup = true;
  		Observable.interval(3000)
		    .takeWhile(() => this.showResendMessagePopup)
		    .subscribe(i => { 
	        	this.showResendMessagePopup = false;
	    })
      }, (err) => {
      	this.isSuccess = false;
      	this.showResendMessagePopup = true;
      	Observable.interval(3000)
		    .takeWhile(() => this.showResendMessagePopup)
		    .subscribe(i => { 
	        	this.showResendMessagePopup = false;
	    })
      })
  	return true;
  }
  
  ngOnDestroy() {
  	this.loginService.signOut(null);
  }

}



// WEBPACK FOOTER //
// C:/Work/Projects/OnlineParser/web2-ui/src/app/custom-modals/verify-your-email-modal.component.ts